<div class="dtf-olp" style="background-color: #E6E6E6;">

  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">

      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState"
          (change)="onChangeButton($event)">
          <mat-button-toggle [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a
            Payment</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option1"
            [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option3"
            [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6"
            style="background-color: #00566A !important; color: white !important;">Recurring Payment</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage
            Bank Profile</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option2"
            [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option8"
            [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>

  <div class="container_dashboard" style="padding-top: 0px;">
    <div style="padding-bottom: 21px;">

      <div class="cardlike">
        <h1>{{ 'recurringpayment.header' | translate }}</h1>
      
        <br>
        <div style="font-size: large;">
          <p> You may have upcoming <a href="{{this.baseRedirect}}/home/scheduledpayment"><span
                style="font-weight: bold; color: #00566A;">Scheduled Payments</span></a>. Click here to view the details and
            dates. &nbsp;
            <span>
              <button matIconButton disabled aria-label="Example icon button with an open in new tab icon"
                style="background: transparent; border: none; box-shadow: none;">
                <a href="{{this.baseRedirect}}/home/scheduledpayment"><mat-icon
                    style="color: #00566A; height: 21px;">open_in_new</mat-icon></a>
              </button>
            </span>
          </p>
        </div>
      </div>

      <div class="container_dashboard">
        <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
          <!--Spinner on Login Load-->
          <div class="demo-container">
            <span>{{ 'Invoice.Loading' | translate }}</span>
            <div class="progress-bar">
              <div class="progress-bar-value"></div>
            </div>
          </div>
          <br>
        </div>
       
        <div *ngIf="step1">
        <div style="padding-bottom: 15px;">
          <div class="row" style="display: flex;">
             <div class="col">
              <div class="card" style="width: 95%; padding-bottom: 23px;">
                <h5 style="font-weight: bold;">Apply Recurring Payment to</h5>
                <p>Step 1: Select where the payment should be applied to:</p>
                <div class="row" style="margin-left: 10px; padding-bottom: 13px;">
                  <div class="col-lg-6 col-md-6 ">
                    <mat-radio-group [(ngModel)]="selectedbutton" required (ngModelChange)="radiobuttonclicked()">
                      <mat-radio-button value="Regular"> {{ 'recurringpayment.radiobutton1' | translate }}<span
                          style="color: red;">*</span></mat-radio-button>
                      <mat-radio-button value="Principal">{{ 'recurringpayment.radiobutton2' | translate }}<span
                          style="color: red;">*</span></mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <br>
              </div>
            </div>

           <div class="col">
            <div class="card bank-profile-card" style="width: 95%;">
              <h5 style="font-weight: bold;">Select Bank Account</h5>
              <p>Step 2: Select your preferred payment profile or add a new one</p>

              <div class="row bank-profile-row" style="margin-left: 10px;">
                <div class="col-lg-5 col-md-5 col-sm-4 col-6">
                  <mat-form-field appearance="outline" style="width: 120%;">
                    <mat-label>{{ 'onlinepayment.select1' | translate }}
                      <span style="color: red;">*</span>
                    </mat-label>
                    <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                      <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                        {{ opt.selection }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-7 col-md-7 col-sm-4 col-6">
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <button routerLink="/home/addprofile" class="mbfs-button">
                    + Add Bank Account
                  </button>
                </div>
              </div>
            </div>
          </div>

          </div>
          <br>
        </div>
        </div>


        <div *ngIf="regularpayment">
        <div *ngIf="recurringpaymentstep1">
          <div class="card" style="width: 97%;">

            <h5 style="font-weight: bold;">Set up Recurring Payments</h5>
            <div class="step3-container">
            <button style="float: right;" class="mbfs-button view-scheduled-btn" (click)="Scheduled()">
              View Scheduled Payments
            </button>
            <p>Step 3: Select the account for which you wish to schedule a recurring payment, specify the amount and define the start and end dates.</p>
            </div>
            <br>
            
            <div style="color: black; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="autopayerror">
              Please Note: Accounts already setup with Autopay will not be available for Recurring payment.
            </div>
            
            <div style="color: red; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="invalidR">
              Please correct the following information.
              <ul style="list-style-type: disc;">
                <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace">Please supply the required information. An * indicates a required field. </li>
                <li *ngIf="selectone" style="margin-left:30px;" class="paragrapSpace">Please select at lease one account or less than 10 accounts.</li>
                <li *ngIf="invaliddate" style="margin-left:30px;" class="paragrapSpace">A payment date cannot be scheduled after the requested end date.</li>
                <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace">The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li>
                <div *ngIf="duplicateAgreementNumbers.length > 0" class="error-messages">
                  <p style="color: red; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;"
                    *ngFor="let agreement of duplicateAgreementNumbers">                  
                    Please note only one recurring (monthly) payment schedule is allowed at a time. If you want to delete the existing schedule, please go to View Scheduled Payments.
                  </p>
                </div>
              </ul>
            </div>

            <div *ngIf="regular">
              <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort
                class="recurring-payment">

                <!--US/EN Table loading-->
                <ng-container matColumnDef="{{column.name}}"
                  *ngFor="let column of initRecurringColumns; last as isLast; first as isFirst;">


                  <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                    style="justify-content: left; padding-left: 0px;">
                    <div *ngIf="column.dispFormat=='acct'">
                      <div style="padding-left: 0px;">{{column.display}}</div>
                    </div>
                    <div *ngIf="column.dispFormat=='monthlyamountdue' || column.dispFormat=='paymentamount'">
                      {{column.display}}
                    </div>
                    <div *ngIf="column.dispFormat=='startdate'|| column.dispFormat=='enddate'"> {{column.display}} <br>
                      <span style="font-size: small;">MM/DD/YYYY</span> </div>


                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" style="justify-content: left;">

                    <span class="mobile-label">
                      <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                      <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                      <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                    </span>
                    <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                      {{element[column.name] | currency:'USD':true:'1.2-2'}}
                    </div>
                    <!-- Account Number -->
                    <div *ngIf="column.dispFormat==''">
                      <div class="class-test">
                        <mat-checkbox [disabled]="selection.isSelected >= 10"
                          (click)="$event.stopPropagation(); calculateTotalAmount();"
                          (change)="$event ? selection.toggle(element) : null"
                          [checked]="selection.isSelected(element)">
                        </mat-checkbox>
                      </div>
                    </div>
                    <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                      {{element[column.name]}}
                    </div>
                    <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                      {{element[column.name] | date:'MM/dd/yyyy'}}
                    </div>
                    <div *ngIf="column.dispFormat=='monthlyamountdue'"> <!--Formats date Columns-->
                      {{element[column.name] | currency:'USD':true:'1.2-2'}}
                    </div>
                    <div *ngIf="column.dispFormat=='startdate'"> <!--Formats date Columns-->
                      <mat-form-field appearance="outline"
                        style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        <input matInput [min]="minDate" [max]="maxDate[element.agreementNumber]" [(ngModel)]="element[column.name]"
                          [matDatepicker]="datepicker">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker>
                          <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                            <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' |
                              translate
                              }}</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="column.dispFormat=='enddate'"> <!--Formats date Columns-->
                      <mat-form-field appearance="outline"
                        style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        <input matInput [min]="minDate" [max]="element.endDate" [(ngModel)]="element[column.name]"
                          [matDatepicker]="datepicker">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker>
                          <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                            <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' |
                              translate
                              }}</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="column.dispFormat=='paymentamount'">
                      <mat-form-field appearance="outline"
                        style="width: 70%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        $ <input matInput min="0" type="text" (keypress)="restrictToTwoDecimals($event, element[column.name])" (keypress)="positiveNumberOnly($event)" maxlength="12"
                          style="width:97px;" [(ngModel)]='element[column.name]' id="paymentamount"
                          (focusout)="convertToDecimal(element)" />
                      </mat-form-field>
                      <span
                        *ngIf="selection.isSelected(element) &&(['0.00'].includes(element.amountRecurring)||element.amountRecurring>2000000)"
                        alt="" style="width: 5px;margin-left:5px;">
                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                          style="width: 5px;margin-left:5px;">
                      </span>
                    </div>
                  </mat-cell>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="FilteredMonthlyPaymentResponseList">
                  <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                    [attr.colspan]="displayedRecurringColumns.length">
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedRecurringColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedRecurringColumns;" class="example-element-row"
                  [class.example-expanded-row]="FilteredMonthlyPaymentResponseList === element"
                  (click)="FilteredMonthlyPaymentResponseList = FilteredMonthlyPaymentResponseList === element ? null : element">
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['FilteredMonthlyPaymentResponseList']"
                  class="example-detail-row"></mat-row>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter

                  </td>
                  <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  </td>
                </tr>

              </mat-table>
              <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
              <br>
              <button class="mbfs-button" style="float: right;" (click)="onSubmit()">{{ 'recurringpayment.submit' |
                translate
                }}</button>
            </div>

          </div>
        </div>

        <div *ngIf="recurringpaymentstep2">
          <div class="card">
            <div style="display: flex;">
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="getSelectedBankName()" readonly />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="totalAmount | currency: USD:true:'1.2-2'" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <br>
            <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8"
              matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initRecurringColumnsStep2; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div> {{column.display}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">
                    <div> {{column.display}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='monthlyamountdue'"> <!--Formats Contract String Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='paymentamount'"> <!--Formats Contract String Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='startdate'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngIf="column.dispFormat=='enddate'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="selectedRecurringResponseList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedRecurringColumnsStep2.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedRecurringColumnsStep2"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedRecurringColumnsStep2;" class="example-element-row"
                [class.example-expanded-row]="selectedRecurringResponseList === element"
                (click)="selectedRecurringResponseList = selectedRecurringResponseList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['selectedRecurringResponseList']"
                class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>
            <br>
          </div>

          <br>
          <p style="margin-left: 10px; font-weight: bold;"> Please review the following Authorization Statement before submitting your payment for processing.</p>
          <br>
          <div class="card">
            <p style=" padding: 10px; text-align:justify ;">
              I authorize Daimler Truck Financial Services USA LLC ("DTFS"), to initiate an Electronic Funds Transfer
              ("EFT") in
              the amount, and on the date(s) indicated, from the account I identified in my Bank profile. I represent
              that the
              bank account information I provided is for an account located in the United States, and in the event the
              account
              is not under my sole ownership, I am authorized to initiate EFTs from the account. For payments scheduled
              in
              advance, I may cancel this authorization by accessing my scheduled payments in my account on
              Daimler-truckfinancial.com and cancelling as provided therein before 11:59 pm ET on the day before the
              scheduled
              payment. Same day payments scheduled between 12:00 AM and 11:59 PM ET post immediately and cannot be
              cancelled. If
              a payment is scheduled on a weekend or bank holiday, it will be deducted from my account on the next
              business day.
              This authorization will remain in effect until I cancel it by the method provided herein, DTFS cancels it
              in
              writing, or all obligations of my lease or retail installment contract are satisfied. In the event my
              contract
              terminates early, any recurring EFT scheduled after the actual contract termination date will not occur.
              <br><br>
              <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not
              be
              deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or
              an
              amendment to the payment due dates in my lease, retail installment contract or promissory note and
              security
              agreement.
            </p>
          </div>
          <br>
          <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
            <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>
          </mat-checkbox>
          <br>
          <br>
           <div style="display:flex;flex-direction: row;gap:10px" >
          <div *ngIf="agentview ==='true'">
            <button class="mbfs-button" disabled>Authorize</button>
          </div>
           <div *ngIf="agentview !='true'">
            <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="RecurringPaymentAuthorize()">Authorize</button>
           </div>
          
          <button class="mbfs-button" (click)="back2step1()">Cancel</button>
           </div>
        </div>


        <div *ngIf="recurringpaymentstep3">
          <div class="card">
            <p style="font-weight: bold;"> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and
              retain
              them for your records.</p>
            <br>
            <div style="display: flex;">
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline" style="width: 110%;">
                    <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="getSelectedBankName()" readonly />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline" style="width: 110%;">
                    <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="totalAmount | currency: USD:true:'1.2-2'" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div *ngIf="failureError" style="color: red;
                                      font-size: 15px;
                                      font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
              We are currently experiencing technical difficulties, Please try again later.
            </div>
            <br>
            <mat-table [dataSource]="subscriptionDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort style="pointer-events: none;">
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initColumns1; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="pointer-events: none;">
                  <div> {{column.display}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="pointer-events: none;">
                  <span class="mobile-label">
                    <div> {{column.display}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='monthlyamountdue'"> <!--Formats Contract String Columns-->
                    {{element.line_items[0].alfa_agreement_number | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='acct'"> <!--Formats Contract String Columns-->
                    {{element.line_items[0].description}}
                  </div>
                  <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                    {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngIf="column.dispFormat=='date2'"> <!--Formats date Columns-->
                    {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="subscriptionResponseList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedColumns1.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedColumns1;" class="example-element-row"
                [class.example-expanded-row]="subscriptionResponseList === element"
                (click)="subscriptionResponseList = subscriptionResponseList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['subscriptionResponseList']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                </td>
              </tr>

            </mat-table>
          </div>
          <br>
          <button class="mbfs-button" (click)="DownloadPdf()">Print</button>
          <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>

        </div>

      </div>

      <div *ngIf="principalpayment">

        <div *ngIf="principalpaymentstep1">
          <div class="card" style="width: 97%;">

            <h5 style="font-weight: bold;">Set up Recurring Payments</h5>
            <div class="step3-container">
            <button style="float: right;" class="mbfs-button view-scheduled-btn" (click)="Scheduled()">
              View Scheduled Payments
            </button>
            <p>Step 3: Select the account for which you wish to schedule a recurring payment, specify the amount and define the start and end dates.</p>
            </div>
            <br>

            <div *ngIf="showWarning"
              style="color: black; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;"
              class="warning-message">
              {{ warningMessage }}
            </div>

           

            <div
              style="color: red; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="invalidPr">
              Please correct the following information.
              <ul style="list-style-type: disc;">
                <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace">Please supply the required information. An * indicates a required field. </li>
                <li *ngIf="selectone" style="margin-left:30px;" class="paragrapSpace">Please select at lease one account or less than 10 accounts.</li>
                <li *ngIf="invaliddate" style="margin-left:30px;" class="paragrapSpace">A payment date cannot be scheduled after the requested end date.</li>
                <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace">The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li>
                <div *ngIf="duplicateAgreementNumbers.length > 0" class="error-messages">
                <p style="color: red; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngFor="let agreement of duplicateAgreementNumbers">
                  Please note: Only one recurring (monthly) payment schedule is allowed at a time. If you want to delete the existing schedule, please go to View Scheduled Payments. 
                </p>
              </div>
              </ul>
            </div>

            <div *ngIf="principal">
              <mat-table [dataSource]="PrincipalDatasource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                <!--US/EN Table loading-->
                <ng-container matColumnDef="{{column.name}}"
                  *ngFor="let column of initPrincipalPaymentColumns; last as isLast; first as isFirst;">


                  <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style=" justify-content: left;">

                    <!-- Principal Amount -->
                    <div *ngIf="column.dispFormat=='principalamount'">
                      {{column.display }}
                    </div>
                    <!-- Payment Date -->
                    <div *ngIf="column.dispFormat=='date'">
                      {{column.display}} <br> <span style="font-size: small;">MM/DD/YYYY</span>

                    </div>
                    <div *ngIf="column.dispFormat=='date1'">
                      {{column.display}} <br> <span style="font-size: small;">MM/DD/YYYY</span>

                    </div>
                    <!-- Account Number -->
                    <div *ngIf="column.dispFormat=='acct'">
                      <div class="row"> {{column.display}}</div>
                    </div>

                  </mat-header-cell>

                  <mat-cell *matCellDef="let element" style="justify-content: left;">
                    <span class="mobile-label">
                      <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                      <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                      <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                    </span>
                    <!-- Principal Amount -->
                    <div *ngIf="column.dispFormat=='principalamount'">
                      <mat-form-field appearance="outline"
                        style="width: 70%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        $ <input matInput type="text" (keypress)="restrictToTwoDecimals($event, element[column.name])" (keypress)="positiveNumberOnly($event)" maxlength="12"
                          style="width:97px;" [(ngModel)]="element.principalAmount" id="principalamount"
                          (focusout)="convertToDecimalPr(element)" />
                      </mat-form-field>
                      <span
                        *ngIf="selectionPr.isSelected(element) &&(['0.00'].includes(element.principalAmount)||element.principalAmount>2000000)"
                        alt="" style="width: 5px;margin-left:5px;">
                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                          style="width: 5px;margin-left:5px;">
                      </span>
                    </div>
                    <div *ngIf="column.dispFormat==''">
                      <div class="class-test">
                        <mat-checkbox (click)="$event.stopPropagation(); calculateTotalAmountPr();"
                          (change)="$event ? selectionPr.toggle(element) : null"
                          [checked]="selectionPr.isSelected(element)">
                        </mat-checkbox>
                      </div>
                    </div>
                    <!-- Account Number -->
                    <div *ngIf="column.dispFormat=='acct'">
                      {{element[column.name]}}
                    </div>
                    <!-- Payment Date -->
                    <div *ngIf="column.dispFormat=='date'">
                      <mat-form-field appearance="outline"
                        style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        <input matInput [min]="minDate" [max]="maxDate[element.agreementNumber]" [(ngModel)]="element[column.name]"
                          [matDatepicker]="datepicker">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker>
                          <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                            <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' |
                              translate
                              }}</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="column.dispFormat=='date1'">
                      <mat-form-field appearance="outline"
                        style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                        <input matInput [min]="minDate" [max]="element.endDate" [(ngModel)]="element[column.name]"
                          [matDatepicker]="datepicker">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker>
                          <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                            <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' |
                              translate
                              }}</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>

                  </mat-cell>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="FilteredPrinciplePaymentResponseList">
                  <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                    [attr.colspan]="displayedPrinicpalPaymentColumns.length">
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedPrinicpalPaymentColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedPrinicpalPaymentColumns;"
                  class="example-element-row" [class.example-expanded-row]="FilteredPrinciplePaymentResponseList === element"
                  (click)="FilteredPrinciplePaymentResponseList = FilteredPrinciplePaymentResponseList === element ? null : element">
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['FilteredPrinciplePaymentResponseList']"
                  class="example-detail-row"></mat-row>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter

                  </td>
                  <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  </td>
                </tr>

              </mat-table>
              <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
              <br>
              <button class="mbfs-button" style="float: right;" (click)="onSubmitPr()">{{ 'recurringpayment.submit' |
                translate }}</button>
            </div>
          </div>
        </div>

        <div *ngIf="principalpaymentstep2">
          <div class="card">
            <div style="display: flex;">
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="getSelectedBankName()" readonly />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="totalAmountPr | currency: USD:true:'1.2-2'" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <mat-table [dataSource]="PrincipalDatasource" multiTemplateDataRows class="mat-elevation-z8"
              matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initPrincipalPaymentColumns2; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div> {{column.display}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">
                    <div> {{column.display}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='principalamount'">
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='acct'">
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''">
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'">
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>

                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="selectedPrincipalResponseList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedPrinicpalPaymentColumns2.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedPrinicpalPaymentColumns2"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedPrinicpalPaymentColumns2;" class="example-element-row"
                [class.example-expanded-row]="selectedPrincipalResponseList === element"
                (click)="selectedPrincipalResponseList = selectedPrincipalResponseList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['selectedPrincipalResponseList']"
                class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>
            <br>
          </div>

          <br>
          <p style="margin-left: 10px; font-weight: bold;"> Please review the following Authorization Statement before submitting your payment for processing.</p>
          <br>
          <div class="card">
            <p style="padding: 10px; text-align:justify ;">
              I authorize Daimler Truck Financial Services USA LLC ("DTFS"), to initiate an Electronic Funds Transfer
              ("EFT") in
              the amount, and on the date(s) indicated, from the account I identified in my Bank profile. I represent
              that the
              bank account information I provided is for an account located in the United States, and in the event the
              account
              is not under my sole ownership, I am authorized to initiate EFTs from the account. For payments scheduled
              in
              advance, I may cancel this authorization by accessing my scheduled payments in my account on
              Daimler-truckfinancial.com and cancelling as provided therein before 11:59 pm ET on the day before the
              scheduled
              payment. Same day payments scheduled between 12:00 AM and 11:59 PM ET post immediately and cannot be
              cancelled. If
              a payment is scheduled on a weekend or bank holiday, it will be deducted from my account on the next
              business day.
              This authorization will remain in effect until I cancel it by the method provided herein, DTFS cancels it
              in
              writing, or all obligations of my lease or retail installment contract are satisfied. In the event my
              contract
              terminates early, any recurring EFT scheduled after the actual contract termination date will not occur.
              <br><br>
              <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not
              be
              deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or
              an
              amendment to the payment due dates in my lease, retail installment contract or promissory note and
              security
              agreement.
            </p>
          </div>
          <br>
          <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
            <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>
          </mat-checkbox>
          <br>
          <br>
          <div style="display:flex;flex-direction: row;gap:10px">
            <div *ngIf="agentview ==='true'">
              <button class="mbfs-button" disabled>Authorize</button>
            </div>
            <div *ngIf="agentview !='true'">
              <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="PrincipalPaymentAuthorize()">Authorize</button>
            </div>
          
            <button class="mbfs-button" (click)="back2step1Pr()">Cancel</button>
          </div>
        </div>

        <div *ngIf="principalpaymentstep3">
          <div class="card">
            <p style="font-weight: bold;"> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and
              retain
              them for your records.</p>
            <div style="display: flex;">
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="getSelectedBankName()" readonly />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                    <input matInput [value]="totalAmountPr | currency: USD:true:'1.2-2'" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div *ngIf="failureError" style="color: red;
                                      font-size: 15px;
                                      font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
              We are currently experiencing technical difficulties, Please try again later.
            </div>
            <br>
            <mat-table [dataSource]="subscriptionDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort style="pointer-events: none;">
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initColumns1; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="pointer-events: none;">
                  <div> {{column.display}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="pointer-events: none;">
                  <span class="mobile-label">
                    <div> {{column.display}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='monthlyamountdue'"> <!--Formats Contract String Columns-->
                    {{element.line_items[0].alfa_agreement_number | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='acct'"> <!--Formats Contract String Columns-->
                    {{element.line_items[0].description}}
                  </div>
                  <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                    {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngIf="column.dispFormat=='date2'"> <!--Formats date Columns-->
                    {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="subscriptionResponseList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedColumns1.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedColumns1;" class="example-element-row"
                [class.example-expanded-row]="subscriptionResponseList === element"
                (click)="subscriptionResponseList = subscriptionResponseList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['subscriptionResponseList']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>

          </div>
          <br>
          <button class="mbfs-button" (click)="DownloadPdfPr()">Print</button>
          <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>
        </div>

      </div>


      <div *ngIf="scheduledpayment">
        <div class="card" style="margin-left: 20px; width: 98%;">
          <p style="margin-bottom: 0px;">Search By: </p>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-2 col-6">
              <p class="filter" style="font-weight: bold; font-size: 15px;">{{ 'recurringpayment.filter1' |
                translate }}</p>
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>{{ 'recurringpayment.filter1label' | translate }}</mat-label>
                    <input matInput style="outline: none;" #input (keyup)="applyFilterAcc($event.target.value)" type="text">
                    <img matSuffix class="example-form-img"
                      src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-2 col-6">
              <p class="filter" style="font-weight: bold; font-size: 15px;">{{ 'recurringpayment.filter2' | translate
                }}</p>
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline" style=" width: 100%; height: 55px;">
                    <mat-label>Status</mat-label>
                    <mat-select (selectionChange)="applyStatusFilter($event.value)">
                      @for (status of statuses; track status) {
                      <mat-option [value]="status.value">{{status.viewValue}}</mat-option>
                      }
                    </mat-select>
                    <img matSuffix class="example-form-img"
                      src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-5 col-6">
              <p class="filter" style="font-weight: bold; font-size: 15px;">{{ 'recurringpayment.filter3' | translate
                }} </p>
              <div class="row">
                <div class="col">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'recurringpayment.filter3label' | translate }}</mat-label>
                
                  <mat-date-range-input [rangePicker]="picker" [(ngModel)]="selectedDateRange">
                    <input matStartDate placeholder="Start date" (dateChange)="onDateRangeChange($event)">
                    <input matEndDate placeholder="End date" (dateChange)="onDateRangeChange($event)">
                  </mat-date-range-input>
                
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                
                  <img matSuffix class="example-form-img" style="display: inline-block; margin-top: -15px;"
                    src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>

                </div>
              </div>
            </div>
          </div>
        </div>
        <br>

        <!-- Recurring Payment Table  -->

        <div class="card">

          <h5 style="font-weight: bold;">{{ 'recurringpayment.tableheader1' | translate }}</h5>

          <p>Edit, or Terminate your existing scheduled payments to ensure your preferences are always up to date.</p>

          <div *ngIf="showerror" style="color: red;">
            Please select one subscription to terminate.
          </div>

          <mat-table [dataSource]="HistoricalSubscriptionDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
            <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}"
              *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <mat-header-cell mat-sort-header  *matHeaderCellDef>
                <div> {{column.display}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">
                  <div> {{column.display}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='select'">
                  <div style="padding-left: 24px;">
                    <mat-checkbox (click)="$event.stopPropagation();"
                      (change)="$event ? selectionHis.toggle(element) : null" [checked]="selectionHis.isSelected(element)">
                    </mat-checkbox>
                  </div>
                </div>
                <div *ngIf="column.dispFormat=='paymentamount'"> <!--Formats Contract String Columns-->
                  {{ ( element.calculated_amounts.gross_order_total / 100 ) | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                  {{element.line_items[0].description}}
                </div>
                <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                  {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                </div>
                <div *ngIf="column.dispFormat=='date2'"> <!--Formats date Columns-->
                  {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                </div>
                 <div *ngIf="column.dispFormat=='transaction'"> <!--Formats String Columns-->
                  {{element.reference}}
                </div>
                 <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                  {{element.status}}
                </div>
              </mat-cell>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="subscriptionList">
              <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                [attr.colspan]="displayedColumns.length">
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
              [class.example-expanded-row]="subscriptionList === element"
              (click)="subscriptionList = subscriptionList === element ? null : element">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['subscriptionList']"
              class="example-detail-row"></mat-row>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
              <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
              </td>
            </tr>

          </mat-table>
          <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>

          <br>
          <div style="display:flex;flex-direction: row;gap:10px">
            <div *ngIf="agentview ==='true'">
              <button class="mbfs-button" disabled>TERMINATE</button>
            </div>
            <div *ngIf="agentview !='true'">
              <button class="mbfs-button"  [disabled]="isTerminateDisabled()" (click)="Remove()">TERMINATE</button>
            </div>
            <button *ngIf="regular" class="mbfs-button" (click)="Back2recpay()">BACK</button>
          </div>

        </div>
      </div>

      <div *ngIf="CancelSubscriptionSuccess">

        <div class="card">
          <p>The subscription is cancelled.</p>

          <mat-table [dataSource]="CancelSubscriptionDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
            <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}"
              *ngFor="let column of CancelSubinitColumns; last as isLast; first as isFirst;">
              <mat-header-cell mat-sort-header  *matHeaderCellDef>
                <div> {{column.display}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">
                  <div> {{column.display}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                  {{element.line_items[0].description}}
                </div>
                <div *ngIf="column.dispFormat=='paymentamount'"> <!--Formats String Columns-->
                  {{ (element.calculated_amounts.gross_order_total / 100) | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='date1'"> <!--Formats String Columns-->
                  {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                </div>
                <div *ngIf="column.dispFormat=='date2'"> <!--Formats String Columns-->
                  {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                </div>
                <div *ngIf="column.dispFormat=='transaction'" style="color: red;"> <!--Formats String Columns-->
                  {{element.reference}}
                </div>
                <div *ngIf="column.dispFormat=='status'" style="color: red;"> <!--Formats String Columns-->
                  {{element.status}}
                </div>
              </mat-cell>
            </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="CancelSubscriptionData">
              <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                [attr.colspan]="displayedColumnsCancelSub.length">
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumnsCancelSub"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumnsCancelSub;" class="example-element-row"
              [class.example-expanded-row]="CancelSubscriptionData === element"
              (click)="CancelSubscriptionData = CancelSubscriptionData === element ? null : element">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['CancelSubscriptionData']"
              class="example-detail-row"></mat-row>
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
              <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
              </td>
            </tr>
          </mat-table>
          <br>
        </div>
        <button class="mbfs-button" (click)="CancelledSubscription()">DONE</button>
      </div>
    </div> 
    </div>
  </div>
</div>